import { render, staticRenderFns } from "./zibalPayment.vue?vue&type=template&id=71d6cccd&scoped=true&"
import script from "./zibalPayment.vue?vue&type=script&lang=js&"
export * from "./zibalPayment.vue?vue&type=script&lang=js&"
import style0 from "./zibalPayment.vue?vue&type=style&index=0&id=71d6cccd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d6cccd",
  null
  
)

export default component.exports